<template>
	<div>
		<template v-if="param.list && param.list.length">
			<template v-if="param.is_swiper == 0">
				<div class="seat-box" :style="{width: param.definition_mode == 0 ? '1190px' : param.seat_width+'px',height: param.seat_height+'px'}">
					<template v-for="(item,index) in param.list">
						<!-- 本窗口 -->
						<template v-if="item.open_type == 0">
							<!-- 外部链接 -->
							<template v-if="item.page_url.indexOf('http') != -1">
								<a :href="item.page_url"><img class="img-default" :src="item.pic_url" alt="" /></a>
							</template>
							<!-- 内部链接 -->
							<template v-else>
								<router-link :to="item.page_url"><img class="img-default" :src="item.pic_url" alt="" /></router-link>
							</template>
						</template>
						<!-- 新窗口 -->
						<template v-else>
							<!-- 外部链接 -->
							<template v-if="item.page_url.indexOf('http') != -1">
								<a :href="item.page_url" target="_blank"><img class="img-default" :src="item.pic_url" /></a>
							</template>
							<!-- 内部链接 -->
							<template v-else>
								<router-link :to="item.page_url" target="_blank"><img class="img-default" :src="item.pic_url" /></router-link>
							</template>
						</template>
					</template>
				</div>
			</template>
			<template v-else>
				<div class="seat-box swiper-container seat-swiper" :class="'seat-swiper'+index" :data-id="index" :style="{width: param.definition_mode == 0 ? '1190px' : param.seat_width+'px',height: param.seat_height+'px'}">
					<div class="swiper-wrapper clearfloat" style="transform:translate3d(0px, 0px, 0px)">
						<div class="swiper-slide new-bannerlist" v-for="(item,index) in param.list" :key="index">
							<!-- 本窗口 -->
							<template v-if="item.open_type == 0">
								<!-- 外部链接 -->
								<template v-if="item.page_url.indexOf('http') != -1">
									<a :href="item.page_url"><img class="img-default" :src="item.pic_url" alt="" /></a>
								</template>
								<!-- 内部链接 -->
								<template v-else>
									<router-link :to="item.page_url"><img class="img-default" :src="item.pic_url" alt="" /></router-link>
								</template>
							</template>
							<!-- 新窗口 -->
							<template v-else>
								<!-- 外部链接 -->
								<template v-if="item.page_url.indexOf('http') != -1">
									<a :href="item.page_url" target="_blank"><img class="img-default" :src="item.pic_url" /></a>
								</template>
								<!-- 内部链接 -->
								<template v-else>
									<router-link :to="item.page_url" target="_blank"><img class="img-default" :src="item.pic_url" /></router-link>
								</template>
							</template>
						</div>
					</div>
					<!-- 如果需要分页器 -->
					<div class="swiper-pagination seat-p"></div>
				</div>
			</template>
		</template>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	import "./index.css";
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			},
			index: {
				type: Number,
				default () {
					return 0;
				}
			}
		},
		data() {
			return {

			};
		},
		mounted() {
			let swiper_list = document.getElementsByClassName("seat-swiper");
			for(let i = 0;i<swiper_list.length;i++){
				let index = swiper_list[i].getAttribute("data-id")
				new Swiper(".seat-swiper"+index, {
					observer: true,
					observeParents: true,
					speed: 1000,
					autoplay: {
						delay: 3000,
						disableOnInteraction: false,
					},
					pagination: {
						el: ".seat-swiper"+index+" .seat-p",
						clickable: true,
					},
				});
			}
		}
	};
</script>

<style lang="scss" scoped>
	.seat-box {
		margin-top: 20px;
		overflow: hidden;
	}
</style>
